const VISITOR_KEY = "product-analytics:visitor:v1";

export function analyticsVisitorId(): string {
  try {
    const current = localStorage.getItem(VISITOR_KEY);
    if (current) return current;
    const created = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, created);
    return created;
  } catch {
    return "anonymous";
  }
}

export function trackEvent(
  event: string,
  fields: Record<string, string | number | undefined> = {},
): void {
  void fetch("/analytics/api/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      product: "sankey",
      event,
      visitor_id: analyticsVisitorId(),
      path: location.pathname,
      referrer: document.referrer,
      ...fields,
    }),
    keepalive: true,
  }).catch(() => undefined);
}
